<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="importAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalGalleryVisible" :vm-is-valid="!$v.gallery.$invalid && !$v.files.$invalid" vm-title='Add Photo')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file" ref="file" @change="handleFileUpload()" accept="image/jpeg, image/x-png")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("gallery.description_placeholder")' v-model="gallery.description" :label='$t("gallery.description")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-date-picker(style="width: 100%" :label='$t("gallery.date")' v-model="gallery.date")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-typeahead(url="shipments" :label='$t("gallery.shipment_id")' disable-match :serializer="item => item.name" :data="inOrdersCatalog.shipments" :placeholder='$t("gallery.shipment_id_placeholder")' v-model="gallery.shipment_id" :filter="query => `?param=${query},remission_number,addressee&project_id=${project}`" @input-change="autoCompleteFunc")
            template(slot-scope="{data}")
              vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data.id" v-bind:text="item.text" v-for="item,index in data")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalGallery',
  props: {
    gallery: {
      type: Object
    },
    project: {
      type: Number
    }
  },
  validations: {
    gallery: {
      shipment_id: {}
    },
    files: {
      required: requiredIf(function () { return this.imageValidate })
    }
  },
  computed: {
    ...mapGetters([
      'isModalGalleryVisible',
      'inOrdersCatalog'
    ]),
    imageValidate () {
      return this.files.length < 1
    }
  },
  data: () => ({
    files: []
  }),
  methods: {
    ...mapActions([
      'setModalGalleryVisible',
      'loadCatalog',
      'importData'
    ]),
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
      this.files = this.$refs.file.files
    },
    importAction () {
      this.importData({ gallery: this.gallery, file: this.file, thumbnail: this.file.name.replace(/(\.[\w\d_-]+)$/i, '_thumbnail$1'), project_id: this.project, mime_type: this.file.type })
    },
    close () {
      this.setModalGalleryVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
